import { type ScreenReducerType } from "./contract";
import { reducerTypes } from "./reducerTypes";

const { RENDER_SCREEN, TOGGLE_NEWSLETTER, UPDATE_MULTISESSION_TOKEN } =
  reducerTypes;

export const screenReducer: ScreenReducerType = (state, action) => {
  switch (action.type) {
    case RENDER_SCREEN:
      return {
        ...state,
        previousScreen: state.screen,
        ...action.payload,
        userData: {
          ...state.userData,
          ...action.payload?.userData,
        },
      };
    case TOGGLE_NEWSLETTER:
      return {
        ...state,
        userData: {
          ...state.userData,
          acceptsNewsletter: !state.userData.acceptsNewsletter,
        },
      };
    case UPDATE_MULTISESSION_TOKEN:
      return {
        ...state,
        userData: {
          ...state.userData,
          multiSessionToken:
            action.payload?.userData?.multiSessionToken ??
            state.userData.multiSessionToken,
        },
      };
    default:
      return state;
  }
};
